export class TiposDoadores {
	id: number;
	codigo: string;
	descricao: string;
	idInstituicao: number;
	usuarioAlteracao: number;
}